import React from 'react'
type AppProps = {
    registerUnderDetails: any;
    handleRegisterUnderDetailsChange: (data: any) => void;
     isDisabled?:boolean
}
const RegisteredUnder = ({
    registerUnderDetails,
    handleRegisterUnderDetailsChange,
    isDisabled
}: AppProps) => {
    return (
        <>
            <div className='row'>
                <div className="col-md-3">
                    <label htmlFor="iecCode">IEC Code</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="text"
                            className="form-control"
                            name="iecCode"
                            value={registerUnderDetails?.iecCode}
                            onChange={(e) => handleRegisterUnderDetailsChange(e)}
                             disabled={isDisabled}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <label htmlFor="msmeUdhyamRegistration">MSME Udhyam Registration</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="text"
                            className="form-control"
                            name="msmeUdhyamRegistration"
                            value={registerUnderDetails?.msmeUdhyamRegistration}
                            onChange={(e) => handleRegisterUnderDetailsChange(e)}
                             disabled={isDisabled}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <label htmlFor="startupIndia">Startup India</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="text"
                            className="form-control"
                            name="startupIndia"
                            value={registerUnderDetails?.startupIndia}
                            onChange={(e) => handleRegisterUnderDetailsChange(e)}
                             disabled={isDisabled}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <label htmlFor="80-IAC Application">80-IAC Application</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="text"
                            className="form-control"
                            name="iacApplication"
                            value={registerUnderDetails?.iacApplication}
                            onChange={(e) => handleRegisterUnderDetailsChange(e)}
                             disabled={isDisabled}
                        />
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className="col-md-6 mt-3">
                    <label htmlFor="gumasta">Gumasta</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="textArea"
                            className={`form-control`}
                            name="gumasta"
                            value={registerUnderDetails?.gumasta}
                            onChange={(e) => handleRegisterUnderDetailsChange(e)}
                             disabled={isDisabled}
                        />
                    </div>
                </div>
                <div className="col-md-6 mt-3">
                    <label htmlFor="trademark">Trademark</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="textArea"
                            className={`form-control`}
                            name="trademark"
                            value={registerUnderDetails?.trademark}
                            onChange={(e) => handleRegisterUnderDetailsChange(e)}
                             disabled={isDisabled}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default RegisteredUnder